export default __webpack_public_path__ + "static/media/SmartMang.fb2c8f1a.svg";